<template>
  <img
    src="logo.svg"
    style="
      position: absolute;
      float: left;
      margin-top: 20px;
      margin-left: 60px;
      width: 110px;
    "
  />

  <div style="width: 1250px; margin: auto">
    <el-container>
      <el-header style="margin-bottom: 120px">
        <div style="margin-top: 60px">
          <h1 style="font-size: 50px">
            <img src="faucet.png" style="width: 70px" /> BitTorrent Chain Donau
            Faucet
          </h1>
        </div>
      </el-header>
    </el-container>

    <el-row :gutter="12">
      <el-col :span="15">
        <el-card class="box-card" shadow="always">
          <h2>Get Testnet Tokens</h2>
          <span
            >Testnet tokens obtained from the faucet can be transferred between
            BitTorrent Chain Donau and TRON/Ethereum/BSC Testnets through
          </span>
          <el-link
            href="https://test-app.bt.io/bridge"
            :underline="false"
            target="_blank"
            type="primary"
            >BitTorrent Bridge.</el-link
          >
          <h2>Choose a Network</h2>
          <div
            class="nav"
            style="text-align: center; margin-right: -10px; margin-top: 35px"
          >
            <router-link to="/" style="margin-left: -10px"
              >BitTorrent Chain Donau</router-link
            >
            <router-link to="/tron" style="margin-left: 8px"
              >TRON Nile Testnet</router-link
            >
            <router-link to="/eth" style="margin-left: 8px">
              Ethereum Sepolia
            </router-link>
            <router-link to="/bsc" style="margin-left: 8px"
              >Binance Chain Testnet</router-link
            >
          </div>
          <router-view />
        </el-card>
      </el-col>
      <el-col :span="9">
        <el-card class="box-card-main" shadow="always">
          <info-page />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.box-card {
  margin-left: -15px;

  height: 1050px;
  background-color: #ffffff;
  width: 690px;
}
.box-card-main {
  margin-left: -100px;
  height: 1050px;
  background-color: #ffffff;
  width: 570px;
}

.el-header {
  color: var(--el-text-color-primary);
  text-align: center;
  line-height: 60px;
  margin-bottom: 70px;
}

.el-aside {
}

.el-main {
  padding: 0px;
  color: var(--el-text-color-primary);
}

body > .el-container {
  margin-bottom: 40px;
}

a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}

.nav a {
  height: 45px;
  text-align: center;
  padding: 10px 8px;
  background: #ecf5ff;
  border-radius: 3px;
  border: solid 1px #409eff;
  font-size: 14px;
  font-weight: bold;
  color: #409eff;
}

.nav a.router-link-exact-active {
  background-color: #409eff;
  color: #ecf5ff;
}
.nav a:hover {
  background-color: #409eff;
  color: #ecf5ff;
}

.nav span {
  font-weight: bold;
  border: solid 1px #409eff;
  text-align: center;
  padding: 0px;
  font-size: 12px;
  border-radius: 5px;
  background: #ecf5ff;
  padding: 13px;
  margin: 3px;
  height: 45px;
  color: #409eff;
}

.nav span:hover {
  background: #409eff;
  color: #ffffff;
}
.nav span.router-link-exact-active {
  background: #409eff;
  color: #ffffff;
}
</style>

<script>
import { defineComponent } from 'vue';
import InfoPage from '../src/views/Info.vue';
import config  from './config';

export default defineComponent({
  name: 'Info',
  components: {
    InfoPage,
  },
  created() {
    // console.log(config.onlineEnv)
    if(config.onlineEnv){
      if (!window.console) {
        window.console = {};
      }
      const methods = ['log', 'debug', 'warn', 'info', 'error'];
      for (var i = 0; i < methods.length; i++) {
        console[methods[i]] = function() {};
      }
      try{
        window.document.oncontextmenu = function () {
          return false; 
        };
      }catch{}
      try{
        window.document.onkeydown = function (event) {
          const e = window.event || event
          if(e && e.keyCode == 123) {//F12
            return false;
          }
          if(e && e.keyCode == 73 && (e.ctrlKey || e.metaKey) && e.shiftKey) {
            return false;
          }
          if(e && e.keyCode == 73 && (e.ctrlKey) && e.metaKey) {
            return false;
          }
          if(e && e.keyCode == 85 && e.ctrlKey) {
            return false;
          }
          if(e && e.keyCode == 83 && e.ctrlKey) {
            return false;
          }
        };
      }catch{}
      try{
        if ((window.outerHeight-window.innerHeight)>200) {
          window.location.reload()
        }
        window.onresize = function () {
          if ((window.outerHeight-window.innerHeight)>200) {
            window.location.reload()
          }
        };
      }catch{}
      try{ setInterval(function(){
          const d1 = new Date();
          debugger;
          if ((new Date()).getTime() - d1.getTime() > 100) {
            window.location.reload()
          }
        }, 50); 
      }catch{}
    }

    try{
      window.addEventListener("eip6963:announceProvider", (e)=>{
        console.log('e.detail.info.name', e.detail.info.name)
        if(!window.ethereumProviders){
          window.ethereumProviders = {}
        }
        window.ethereumProviders[e.detail.info.name] = e.detail.provider;
        if(e.detail.info.name === 'MetaMask'){
          window.ethereumMM = e.detail.provider;
          window.ethereum = window.ethereumMM;
          window.ethereumName = e.detail.info.name;
        }
      })
      window.dispatchEvent(new Event('eip6963:requestProvider'))
    }catch{}
  }
});
</script>
